import { render, staticRenderFns } from "./ContributorFieldContainer.vue?vue&type=template&id=5d8e58ef&"
import script from "./ContributorFieldContainer.vue?vue&type=script&lang=js&"
export * from "./ContributorFieldContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports